import { render, staticRenderFns } from "./SessionViewAddStudent.vue?vue&type=template&id=a6c24338&"
import script from "./SessionViewAddStudent.vue?vue&type=script&lang=js&"
export * from "./SessionViewAddStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports